export default __webpack_public_path__ + "static/media/vendit_rope_pattern.7bf24ae9.svg";